import { combineReducers } from '@reduxjs/toolkit'

import { reducer as campaigns } from './campaigns'
import { reducer as customers } from './customers'
import { reducer as detail } from './detail'
import { reducer as importHistory } from './importHistory'
import { reducer as lists } from './lists'

export const reducer = combineReducers({
  lists,
  detail,
  importHistory,
  customers,
  campaigns,
})

// Re-export actions and selectors still in use
export {
  openCreateModal,
  closeCreateModal,
  selectCreateModalOpen,
} from './lists'
export {
  openImportModeModal,
  closeImportModeModal,
  confirmImportMode,
  openImporter,
  closeImporter,
  setActiveImportFileUploadId,
  selectImportModeModalOpen,
  selectImportMode,
  selectImporterOpen,
  selectImporterListId,
  selectActiveImportFileUploadId,
} from './lists'
export type { ImportMode } from './lists'

export {
  setCurrentList,
  setActiveTab,
  selectCurrentListId,
  selectActiveTab,
} from './detail'
export type { DetailTab } from './detail'
